<script lang="ts">
    import ChatMessage from './ChatMessage.svelte';
	import Fa from 'svelte-fa';
	import { faClose } from '@fortawesome/free-solid-svg-icons';
    import Button from '../../components/Button.svelte';
    import { BarLoader } from "svelte-loading-spinners";
    import { getClient, query } from 'svelte-apollo';
    import { GPT_QUERY } from '../../graphql/queries/segments';

    let display = false;

    let nameChatPartner='AdPicker Bot';

    let inputValue: string | null;
    let previousQuery: string = "";
    let inputDisabled = false;
    let varObject = {
        previousQuery: previousQuery,
        userQuery: ""
    };

    const client = getClient();

    const estimatedNumberQuery = query(client, {
            query: GPT_QUERY,
            variables: varObject,
            errorPolicy: 'all'
	    });
	
	let messages = [{"message":"Hey! Hey! I'm AdPicker Bot. You can ask me for details about the number of users in the last day :)","sentByMe":false}];

    async function submitFunction() {
        messages = [...messages, {"message":inputValue,"sentByMe":true}]
        setTimeout(() => {
            document.querySelector(".direct-chat-messages").scrollTop = document.querySelector(".direct-chat-messages").scrollHeight;
        }, 0)
        inputDisabled = true;
        //send message to snowflake and wait for result
        varObject = {
            previousQuery: previousQuery,
            userQuery: inputValue
        }
        const { data } = await estimatedNumberQuery.refetch(varObject);
        previousQuery = data.gptResult.query;
        if (data.gptResult.status === "OK") {
            messages = [...messages, {"message":"There are exactly " + data.gptResult.count + " such users.","sentByMe":false}]
            setTimeout(() => {
                    document.querySelector(".direct-chat-messages").scrollTop = document.querySelector(".direct-chat-messages").scrollHeight;
            }, 100)
            setTimeout(() => {
                messages = [...messages, {"message": data.gptResult.answer, "sentByMe":false}]
                setTimeout(() => {
                    document.querySelector(".direct-chat-messages").scrollTop = document.querySelector(".direct-chat-messages").scrollHeight;
                }, 100)
            }, 1000)
        } else {
            messages = [...messages, {"message":data.gptResult.errorText,"sentByMe":false}]
            setTimeout(() => {
                document.querySelector(".direct-chat-messages").scrollTop = document.querySelector(".direct-chat-messages").scrollHeight;
            }, 100)
        }
        inputValue = "";
        inputDisabled = false;
    }
</script>

<svelte:head>
  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</svelte:head>

<div class={display ? "chat-window displayed" : "chat-window"}>
    {#if !display}
        <img src="/assets/icons/android-chrome-512x512.png" alt="Chat" on:click={() => display = true} />
    {:else}
        <div class="card card-danger direct-chat direct-chat-danger">
            <div class="card-header">
                <div class="card-tools d-flex align-items-center">
                    <span class="contacts-name">{nameChatPartner}</span>
                    <span class="mr-auto"></span>
                    <button type="button" class="btn btn-tool" on:click={() => display = false}><Fa icon={faClose} /></button>
                </div>
            </div>
            <div class="card-body">
                <div class="direct-chat-messages">
                    {#each messages as message}
                        <ChatMessage
                            message={message.message}
                            sentByMe={message.sentByMe} 
                        />
                    {/each}                        
                </div>
            </div>
            <div class="card-footer">
                    <form on:submit|preventDefault={() => submitFunction()}>
                        <div class="input-group">
                            <input type="text" placeholder="Type Message ..." class="form-control" bind:value={inputValue}>
                            <span class="input-group-append">
                                <Button variant="raised">Send</Button>
                            </span>
                        </div>
                    </form>
                    <div class={inputDisabled ? "loader-wrapper displayed": "loader-wrapper"}>
                        <BarLoader size="100" color="#ef4a50" />
                    </div>
            </div>
        </div>
    {/if}
</div>

<style>
    :global(body) {
        background-color: #f5f5f5 !important;
    }

    .loader-wrapper {
        display: none;
        justify-content: center;
        align-items: center;
        position: absolute;
        z-index: 1000;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(255,255,255, 0.8);
    }

    .loader-wrapper.displayed {
        display: flex;
    }

    .chat-window {
        display: none;
    }

    .direct-chat .card-header {
        background-color: black;
        color: white;
    }

    .direct-chat .card-header button {
        color: white;
    }

    .direct-chat .card-footer {
        padding-top: 20px;
        padding-bottom: 20px;
        position: relative;
    }

    .direct-chat .card-body {
		overflow-x: hidden;
		padding: 0;
		position: relative;
	}

	.direct-chat-messages {
		-webkit-transform: translate(0, 0);
		transform: translate(0, 0);
		height: 355px;
		overflow: auto;
		padding: 10px;
		transition: -webkit-transform .5s ease-in-out;
		transition: transform .5s ease-in-out;
		transition: transform .5s ease-in-out, -webkit-transform .5s ease-in-out;
	}

	.contacts-name {
		margin-left: 15px;
		font-weight: 600;
	}

    @media screen and (min-width: 768px) and (min-height: 600px) {
        .chat-window {
            cursor: pointer;
            display: block;
            position: fixed;
            bottom: 0;
            right: 2vw;
            width: 75px;
            height: 75px;
            background-color: #ef4a50;
        }

        .chat-window.displayed {
            cursor: default;
            width: 400px;
            height: 500px;
            background-color: transparent;
        }

        .chat-window > img {
            width: 100%;
            height: 100%;
        }
    }
</style>
